import BC from "../init";

console.log('expand');
export default BC.Methods.loadDetails = ($this) => {
    const content  = $this.querySelector('.user-content');
    const showMoreButton = $this.querySelector('.property-btn');
    let initialText =  content.textContent + '';
    let contentText = JSON.parse(JSON.stringify(initialText))
    let splitSentence = initialText.split('\n').filter(n => n.trim());
    splitSentence = splitSentence.filter(n => n);
    let contentLength = wordCount(contentText);
    // let htmlContent = content.innerHTML;
    if (splitSentence.length > 10) {
        content.textContent = splitSentence.slice(0, 10).join("\n").trim();
        showMoreButton.classList.remove('hide');

        showMoreButton.onclick = function(event) {
            event.preventDefault()
            content.textContent = splitSentence.join("\n").trim();  // Join all lines back
            showMoreButton.classList.add('hide');
        }
    } else {
        showMoreButton.classList.add('hide');
    };
};
function wordCount (str) {
    if (str) {
        return str.split(" ").length;
    }
    return 0;
}
function cutSentence(str) {
    return str.split(" ").splice(0,46).join(" ");
}